export enum CartPaymentMethods {
  Cash = 'Cash',
  Card = 'Card',
  Invoice = 'Invoice',
  CustomerCard = 'CustomerCard',
  CashOut = 'CashOut',
  CustomerCardOut = 'CustomerCardOut',
  CardOut = 'CardOut',
  InvoiceOut = 'InvoiceOut',
  VoucherOut = 'VoucherOut',
}
